import React, { useState, useEffect } from 'react';
import { useTheme } from '@material-ui/core/styles';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  circle: {
    width: 30,
    height: 30,
    marginRight: 10,
    borderRadius: '50%',
  },
  box: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: 50,
    backgroundColor: '#fff',
    '& > div': {
      marginRight: 10,
      marginBottom: 20,
    },
  },
  itemBox: {
    minWidth: 200,
    display: 'flex',
    alignItems: 'center',
    '& h3, & p': { margin: 0 },
  },
}));

const KeysColor = () => {
  const theme = useTheme();
  const classes = useStyles();
  const [colors, setColors] = useState(theme.palette.graph.key);

  useEffect(() => {
    let newColor = [];
    for (const [key, value] of Object.entries(theme.palette.graph.key)) {
      newColor.push({ name: key, color: value });
    }
    setColors(newColor);
    // eslint-disable-next-line
  }, []);

  const nameConverter = (name) => {
    let newName;

    if (name === 'AD') {
      newName = '베이스광고(' + name + ')';
    } else if (name === 'PA') {
      newName = '쇼라베이스(' + name + ')';
    } else if (name === 'CW') {
      newName = '카트매칭(' + name + ')';
    } else if (name === 'OS') {
      newName = '온사이트서치(' + name + ')';
    } else if (name === 'HU') {
      newName = '헤비유저(' + name + ')';
    } else if (name === 'KL') {
      newName = '검색어(' + name + ')';
    } else if (name === 'RC') {
      newName = '관심상품(' + name + ')';
    } else if (name === 'RM') {
      newName = '리턴(' + name + ')';
    } else if (name === 'SA') {
      newName = '브랜드박스(' + name + ')';
    } else if (name === 'SP') {
      newName = '보완재(' + name + ')';
    } else if (name === 'SR') {
      newName = '본상품(' + name + ')';
    } else if (name === 'ST') {
      newName = '투데이베스트(' + name + ')';
    } else if (name === 'US') {
      newName = '유저유사도(' + name + ')';
    } else if (name === 'UM') {
      newName = '성향(' + name + ')';
    } else if (name === 'CM') {
      newName = '카테고리(' + name + ')';
    } else if (name === 'AU') {
      newName = '오디언스(' + name + ')';
    } else if (name === 'MR') {
      newName = '(구)문맥(' + name + ')';
    } else if (name === 'AT') {
      newName = '앱프로파일(' + name + ')';
    } else if (name === 'PR') {
      newName = '프로모션(' + name + ')';
    } else if (name === 'RU') {
      newName = '휴면유저(' + name + ')';
    } else if (name === 'MT') {
      newName = '문맥(' + name + ')';
    } else if (name === 'LC') {
      newName = '라스트클릭(' + name + ')';
    } else if (name === 'TC') {
      newName = '투데이카트(' + name + ')';
    } else if (name === 'TV') {
      newName = '투데이본상품(' + name + ')';
    } else if (name === 'WC') {
      newName = '위클리카트(' + name + ')';
    } else if (name === 'MC') {
      newName = '먼슬리카트(' + name + ')';
    } else if (name === 'CH') {
      newName = '커스텀하이(' + name + ')';
    } else if (name === 'CR') {
      newName = '커스텀리타겟팅(' + name + ')';
    } else if (name === 'WV') {
      newName = '위클리본상품(' + name + ')';
    } else if (name === 'MV') {
      newName = '먼슬리본상품(' + name + ')';
    } else if (name === 'TR') {
      newName = '투데이리턴(' + name + ')';
    } else if (name === 'RE') {
      newName = '리인게이지먼트(' + name + ')';
    } else if (name === 'BP') {
      newName = '가망고객(' + name + ')';
    } else if (name === 'WR') {
      newName = '위클리리턴(' + name + ')';
    } else if (name === 'FR') {
      newName = '먼슬리리턴(' + name + ')';
    } else if (name === 'MO') {
      newName = '미디어(' + name + ')';
    } else if (name === 'TP') {
      newName = '투데이보완재(' + name + ')';
    } else if (name === 'WP') {
      newName = '위클리보완재(' + name + ')';
    } else if (name === 'TM') {
      newName = '발신이력(' + name + ')';
    } else if (name === 'HP') {
      newName = '하프보완재(' + name + ')';
    } else if (name === 'HV') {
      newName = '투데이본상품(' + name + ')';
    } else if (name === 'HE') {
      newName = '헤비리인게이지먼트(' + name + ')';
    } else if (name === 'HR') {
      newName = '원타임리턴(' + name + ')';
    } else if (name === 'HM') {
      newName = '헤비성향(' + name + ')';
    } else if (name === 'PU') {
      newName = '위클리가망고객(' + name + ')';
    } else if (name === 'MU') {
      newName = '먼슬리가망고객(' + name + ')';
    } else if (name === 'RT') {
      newName = '콜리턴(' + name + ')';
    } else if (name === 'PF') {
      newName = '퍼포먼스광고(' + name + ')';
    } else {
      newName = name;
    }
    return newName;
  };

  return (
    <>
      <h3>아래 색상표 외에 타겟팅은 모두 검정색</h3>

      <div className={classes.box}>
        {(() => {
          const result = [];

          for (let i = 0; i < colors.length; i++) {
            const { name, color } = colors[i];

            result.push(
              <div key={name} className={classes.itemBox}>
                <div
                  className={classes.circle}
                  style={{ backgroundColor: color }}
                />
                <div>
                  <h3>{nameConverter(name)}</h3>
                  <p>{color}</p>
                </div>
              </div>
            );
          }
          return result;
        })()}
      </div>
    </>
  );
};

export default KeysColor;
